import React, { useState, useEffect } from "react";
import { FaChevronLeft } from 'react-icons/fa';
import { Row, Col, Card, CardBody, Table, Button, FormGroup, Label, Input, Spinner } from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import uuid from 'react-uuid';
import "../ExternalOrganisation/ExternalOrganisation.css";
import Select, { components, ValueContainerProps } from 'react-select';
import SpinnerContainer from '../Utilities/Ui/SpinnerContainer';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';

const FarmSettings = ({ handleWizardFarmChanged }) => {
    const [userFarms, setUserFarms] = useState([]);
    const [farmSelect, setFarmSelect] = useState(0); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const [optionalPages_Effluent, setOptionalPages_Effluent] = useState(false);
    const [optionalPages_Biosecurity, setOptionalPages_Biosecurity] = useState(false);
    const [optionalPages_ContaminantSelfEvaluation, setOptionalPages_ContaminantSelfEvaluation] = useState(false);
    const [show_HistoricalActions, setShow_HistoricalActions] = useState(false);
    const [show_SectionComment, setShow_SectionComment] = useState(false);
    const [optionalPages_FreshwaterIrrigation, setOptionalPages_FreshwaterIrrigation] = useState(false);
    const [optionalPages_WinterGrazing, setOptionalPages_WinterGrazing] = useState(false);
    const [optionalPages_Cropping, setOptionalPages_Cropping] = useState(false);
    const [optionalPages_Biodiversity, setOptionalPages_Biodiversity] = useState(false);
    const [optionalPages_GreenhouseGass, setOptionalPages_GreenhouseGass] = useState(false);
    const [isHavingDairy, setIsHavingDairy] = useState(false); const navigate = useNavigate();
    const [saving, setSaving] = useState(false);
    const [isReturnstoPlan, setIsReturnstoPlan] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams(); const { state } = useLocation();
    const [showDetail, setShowDetail] = useState(false);
    const populateItemData = async () => {
        try {
            
            if (state != null) {
                const { farmId } = state;
                const response = await axios.get(
                    '/api/settings/GetFarmSettingFarmWise/', {
                        params: { UserId: userId, FarmId: farmId }
                }
                );
                setUserFarms(response.data.content.farmList);
                var farm = response.data.content.farmList.filter(x => x.value == farmId);
                if (farm.length > 0) {
                    handleFarmChange(farm[0]);
                }
            }
            else {
                const response = await axios.get(
                    '/api/settings/getfarmsettings/', {
                    params: { UserId: userId }
                }
                );
                if (response.data.content.userFarmCount == 1) {
                    setIsReturnstoPlan(true);
                }
                else {
                    setIsReturnstoPlan(false);
                }
                setUserFarms(response.data.content.farmList);
                if (response.data.content.farmList.length > 0) {
                    if (response.data.content.farmList.length == 1) {
                        var farm = response.data.content.farmList.filter(x => x.value == response.data.content.farmList[0].value);
                        if (farm.length > 0) {
                            handleFarmChange(farm[0]);
                        }
                    }
                }
            }
        }
        catch (err) {
            if (!err?.response) {

            } else if (err.response?.status === 400) {

            } else {

            }
        }
    }

    useEffect(() => {
        populateItemData();
    }, []);

    const handleFarmChange = async (event) => {
        if (event == null) {
            setShowDetail(false);
        }
        else {
            setShowDetail(true);
        }
        setFarmSelect(event);
        setIsHavingDairy(false);
        setOptionalPages_Effluent(false);
        setOptionalPages_Biosecurity(false);
        setOptionalPages_FreshwaterIrrigation(false);
        setOptionalPages_WinterGrazing(false);
        setOptionalPages_Cropping(false);
        setOptionalPages_Biodiversity(false);
        setOptionalPages_GreenhouseGass(false);
        setOptionalPages_ContaminantSelfEvaluation(false);
        setShow_HistoricalActions(false);
        setShow_SectionComment(false);
        if (event != null) {
            const response = farmChange(event.value);
            toast.promise(response, {
                loading: 'Loading...',
                success: 'Successfully loaded',
                error: 'Error while loading data',
            });

        }
        else {
            setFarmSelect(0);
        }
    }

    

    

    const farmChange = async (farmId) => {
        const response = await axios.get(
            '/api/settings/farmSettingsChange/', {
                params: { Id: farmId }
        }
        );
        if (response.data.status) {
            setIsHavingDairy(response.data.content.isHavingDairy);
            setOptionalPages_Effluent(response.data.content.optionalPages_Effluent);
            setOptionalPages_Biosecurity(response.data.content.optionalPages_Biosecurity);
            setOptionalPages_FreshwaterIrrigation(response.data.content.optionalPages_FreshwaterIrrigation);
            setOptionalPages_WinterGrazing(response.data.content.optionalPages_WinterGrazing);
            setOptionalPages_Cropping(response.data.content.optionalPages_Cropping);
            setOptionalPages_Biodiversity(response.data.content.optionalPages_Biodiversity);
            setOptionalPages_GreenhouseGass(response.data.content.optionalPages_GreenhouseGass);
            setOptionalPages_ContaminantSelfEvaluation(response.data.content.optionalPages_ContaminantSelfEvaluation);
            setShow_HistoricalActions(response.data.content.show_HistoricalActions);
            setShow_SectionComment(response.data.content.show_SectionComment);
        }
    }

    

    const handleSubmit = async (event) => {
        event.preventDefault();
        setSaving(true);
        let form = {
            FarmId: farmSelect.value,
            UserId: userId,
            OptionalPages_Effluent: optionalPages_Effluent,
            OptionalPages_FreshwaterIrrigation: optionalPages_FreshwaterIrrigation,
            OptionalPages_WinterGrazing: optionalPages_WinterGrazing,
            OptionalPages_Cropping: optionalPages_Cropping,
            OptionalPages_Biodiversity: optionalPages_Biodiversity,
            OptionalPages_GreenhouseGass: optionalPages_GreenhouseGass,
            OptionalPages_Biosecurity: optionalPages_Biosecurity,
            OptionalPages_ContaminantSelfEvaluation: optionalPages_ContaminantSelfEvaluation,
            Show_HistoricalActions: show_HistoricalActions,
            Show_SectionComment: show_SectionComment,
        }
        const response = await axios.post(
            '/api/settings/SaveFarmSettings/', JSON.stringify(form),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        if (response.data != null) {
            if (response.data.status) {
                toast.success("Farm Settings Saved!", { duration: 1000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                setSaving(false);
                const response1 = farmChange(farmSelect.value);
                toast.promise(response1, {
                    loading: 'Loading...',
                    success: 'Successfully loaded',
                    error: 'Error while loading data',
                });
            }
        }
    }

    const handleSetFarm = async (id) => {
        const farmId = parseInt(id);
        try {
            const response = await axios.get(
                '/api/settings/getFarmDetail/', {
                params: { farmId: farmId, userId: userId }
            }
            );
            localStorage.setItem("defaultFarmId", JSON.stringify(id));
            localStorage.setItem("defaultFarmName", JSON.stringify(response.data.name));
            localStorage.setItem("defaultFarmUniqueId", JSON.stringify(response.data.uniqueIdentifier));
            handleWizardFarmChanged(farmId);
        } catch (err) {
            if (err?.response) {
                toast.error("No server response");
            }
        }
    }

    const handleClick = async (e) => {
        e.preventDefault(); // Prevents the default anchor behavior (e.g., navigation)
        try {
            const response = await axios.get(
                '/api/settings/GetUsers/', {
                params: {}
            }
            );
            if (response.data != null) {
                var user = response.data.content.users.filter(x => x.id == userId);
                if (user[0].userFarmList.length == 1) {
                    await handleSetFarm(user[0].userFarmList[0].id);
                }
                else if (user[0].userFarmList.length > 0) {
                    window.open("/allfarmssummary", "_self");
                }
                else {
                    toast.error("Sorry, this user does not have any farm allocated to access. Please contact admin team", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                }
            }
        } catch (err) {
            console.log(err);
        }
    };

    return (
        <div>
            <Toaster position="top-center" containerStyle={{ top: '50%' }} />
            <Card className="my-4">
                <h2 className="card-header card-header-dark d-flex justify-content-between align-items-center card-header">
                    Farm Settings
                </h2>
                <CardBody>
                    <Row>
                        <Col className="d-flex" sm="6">
                            <FormGroup>
                                <Label className="label" for="userSelect">Select Property</Label>
                                {userFarms == undefined && <p><em>Loading...</em></p>}
                                {userFarms != undefined && userFarms != null &&
                                    <Select style={{ zIndex: "9999" }}
                                        id="farmSelect" width="max-content"
                                        name="farmSelect"
                                        closeMenuOnSelect={true}
                                        className="dropdown"
                                        placeholder="Select Property"
                                        value={farmSelect}
                                        options={userFarms}
                                        onChange={handleFarmChange}
                                        isClearable hideSelectedOptions={false}
                                    />
                                }
                            </FormGroup>
                        </Col>
                    </Row>
                    
                    {showDetail && 
                        <>
                            <Row>
                                <Col>
                                    <label style={{ fontSize: "26px" }}><b>Customise the farm setup</b></label>
                                </Col>
                            </Row>
                            <Row className="userFarm-tabledetails" id="divDetail">
                                <Col>
                                    <Card className="my-4">
                                        <CardBody>
                                            <Row>
                                                <Col>
                                                    <label style={{ fontSize: "21px" }}><b>Additional mapping pages</b></label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label style={{ fontSize: "19px" }}>Add additional mapping pages to the property if needed. Not all farms may have these mapping requirements.</label>
                                                </Col>
                                            </Row>
                                            <br />
                                            <Row >
                                                <Col>
                                                    <Row>
                                                        <Col sm="6">
                                                            <Row>
                                                                <Col sm="1">
                                                                    <Input type="checkbox" checked={optionalPages_Cropping} onChange={(e) => setOptionalPages_Cropping(!optionalPages_Cropping)} name="optionalPages_Cropping" id="optionalPages_Cropping" />
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Label>Cropping and Cultivation</Label>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <Label style={{ fontSize: "12.5px", textTransform: "none" }}>Enables 'Cropping and Cultivation' Page under "3 - Farm Maps, Infrastructure and Actions". This allows you to map cropping areas, enter crop and harvesting records, and raise actions against these.</Label>
                                                                </Col>
                                                                <Col sm="1">

                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col sm="6">
                                                            <Row>
                                                                <Col sm="1">
                                                                    <Input type="checkbox" disabled={isHavingDairy} checked={optionalPages_Effluent} onChange={(e) => setOptionalPages_Effluent(!optionalPages_Effluent)} name="optionalPages_Effluent" id="optionalPages_Effluent" />
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Label>Effluent</Label>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <Label style={{ fontSize: "12.5px", textTransform: "none" }}>Enables 'Effluent Disposal' Page under "3 - Farm Maps, Infrastructure and Actions". Allows you to map effluent infrastructure and raise actions against them.</Label>
                                                                </Col>
                                                                <Col sm="1">

                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm="6">
                                                            <Row>
                                                                <Col sm="1">
                                                                    <Input type="checkbox" checked={optionalPages_Biodiversity} onChange={(e) => setOptionalPages_Biodiversity(!optionalPages_Biodiversity)} name="optionalPages_Biodiversity" id="optionalPages_Biodiversity" />
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Label>Biodiversity</Label>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <Label style={{ fontSize: "12.5px", textTransform: "none" }}>Enables 'Biodiversity' Page under "3 - Farm Maps, Infrastructure and Actions". This page pulls through all areas that have been marked as being areas of biodiversity from throughout the plan and summerises them on a single page.</Label>
                                                                </Col>
                                                                <Col sm="1">

                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col sm="6">
                                                            <Row>
                                                                <Col sm="1">
                                                                    <Input type="checkbox" checked={optionalPages_FreshwaterIrrigation} onChange={(e) => setOptionalPages_FreshwaterIrrigation(!optionalPages_FreshwaterIrrigation)} name="optionalPages_FreshwaterIrrigation" id="optionalPages_FreshwaterIrrigation" />
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Label>Irrigation</Label>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <Label style={{ fontSize: "12.5px", textTransform: "none" }}>Enables 'Irrigation' Page under "3 - Farm Maps, Infrastructure and Actions". This pulls through any LU marked as irrigated and allows you to map furhter irrigation infrastructure, frost protection areas and soil moisture probes. You can then raise actions against these items.</Label>
                                                                </Col>
                                                                <Col sm="1">

                                                                </Col>
                                                            </Row>
                                                        </Col>

                                                    </Row>
                                                    <Row>
                                                        <Col sm="6">
                                                            <Row>
                                                                <Col sm="1">
                                                                    <Input type="checkbox" checked={optionalPages_Biosecurity} onChange={(e) => setOptionalPages_Biosecurity(!optionalPages_Biosecurity)} name="optionalPages_Biosecurity" id="optionalPages_Biosecurity" />
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Label>Biosecurity</Label>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <Label style={{ fontSize: "12.5px", textTransform: "none" }}>Enables 'Biosecurity' Page under "3 - Farm Maps, Infrastructure and Actions". This page allows you to write commentary around biosecurity risks and risk vectors, as well as processes for risk management or minimisation.</Label>
                                                                </Col>
                                                                <Col sm="1">

                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col sm="6">
                                                            <Row>
                                                                <Col sm="1">
                                                                    <Input type="checkbox" checked={optionalPages_ContaminantSelfEvaluation} onChange={(e) => setOptionalPages_ContaminantSelfEvaluation(!optionalPages_ContaminantSelfEvaluation)} name="optionalPages_ContaminantSelfEvaluation" id="optionalPages_ContaminantSelfEvaluation" />
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Label>Contaminant Self Evaluation</Label>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <Label style={{ fontSize: "12.5px", textTransform: "none" }}>Adds a contaminant self evaluation checklist before the risk assessment page in "2 - My Farm, Land and Community". This asks you questions around each of the four main contaminants and then rates your likely severity of each contaminant.</Label>
                                                                </Col>
                                                                <Col sm="1">

                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col sm="6">
                                                            <Row>
                                                                <Col sm="1">
                                                                    <Input type="checkbox" checked={optionalPages_GreenhouseGass} onChange={(e) => setOptionalPages_GreenhouseGass(!optionalPages_GreenhouseGass)} name="optionalPages_GreenhouseGass" id="optionalPages_GreenhouseGass" />
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Label>Greenhouse Gasses</Label>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <Label style={{ fontSize: "12.5px", textTransform: "none" }}>Enables 'Greenhouse Gases' Page under "3 - Farm Maps, Infrastructure and Actions" This allows you to add commentary or backgorund around GHG or raise actions relating to to GHG.</Label>
                                                                </Col>
                                                                <Col sm="1">

                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col sm="6">
                                                            <Row>
                                                                <Col sm="1">
                                                                    <Input type="checkbox" checked={optionalPages_WinterGrazing} onChange={(e) => setOptionalPages_WinterGrazing(!optionalPages_WinterGrazing)} name="optionalPages_WinterGrazing" id="optionalPages_WinterGrazing" />
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Label>Intensive Winter Grazing</Label>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <Label style={{ fontSize: "12.5px", textTransform: "none" }}>Coming soon....
                                                                    </Label>
                                                                </Col>
                                                                <Col sm="1">

                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label style={{ fontSize: "21px" }}><b>Extra Features / Page Settings</b></label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <label style={{ fontSize: "19px" }}>These additional features may be useful depending on the objective and audience for the plan. They are not compulsory, however can add extra information to a plan which can be useful especially for complex operations.</label>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Label className="label" for="name">Page Settings</Label>
                                                    <Row>
                                                        <Col sm="6">
                                                            <Row>
                                                                <Col sm="1">
                                                                    <Input type="checkbox" checked={show_HistoricalActions} onChange={(e) => setShow_HistoricalActions(!show_HistoricalActions)} name="show_HistoricalActions" id="show_HistoricalActions" />
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Label>Enable Historical Actions</Label>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <Label style={{ fontSize: "12.5px", textTransform: "none" }}>This enables you to add historical actions which can show a history of your completed actions before you started a FWFP.
                                                                    </Label>
                                                                </Col>
                                                                <Col sm="1">

                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                        <Col sm="6">
                                                            <Row>
                                                                <Col sm="1">
                                                                    <Input type="checkbox" checked={show_SectionComment} onChange={(e) => setShow_SectionComment(!show_SectionComment)} name="show_SectionComment" id="show_SectionComment" />
                                                                </Col>
                                                                <Col sm="3">
                                                                    <Label>Show Section Comment</Label>
                                                                </Col>
                                                                <Col sm="7">
                                                                    <Label style={{ fontSize: "12.5px", textTransform: "none" }}>Adds a comments section to each page.
                                                                    </Label>
                                                                </Col>
                                                                <Col sm="1">

                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    {saving ?
                                                        <Button style={{ float: "right" }} onClick={handleSubmit}
                                                            color="success"
                                                            disabled
                                                        >
                                                            <Row>
                                                                <Col sm="8">
                                                                    <span>
                                                                        {' '}Saving
                                                                    </span>
                                                                </Col>
                                                                <Col sm="4">
                                                                    <Spinner size="sm">
                                                                        Saving...
                                                                    </Spinner>
                                                                </Col>
                                                            </Row>
                                                        </Button>
                                                        :
                                                        <Button disabled={farmSelect == 0 ? true : false} style={{ float: "right" }} onClick={handleSubmit} color="success" size="sm">
                                                            Save
                                                        </Button>
                                                }
                                                {   isReturnstoPlan &&
                                                    <Button style={{ float: "right", marginRight: "10px" }} onClick={handleClick} color="success" size="sm">
                                                        <FaChevronLeft />Return to Plan
                                                    </Button>
                                                }
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                        </>
                        
                    }
                    
                </CardBody>
            </Card>
        </div>
    );
}

export default FarmSettings;
